<template>
  <div id="app">
    <Header />
    <div class="grid" v-if="showSidebar">
      <Sidebar />
      <router-view />
    </div>
    <router-view v-else />
  </div>
</template>

<script>
import Header from '@/components/Header'
import Sidebar from '@/components/Sidebar'
export default {
  components: { Sidebar, Header },
  mounted() {
    if (localStorage.getItem('authUser')) {
      this.$store.commit(
        'setAuth',
        JSON.parse(localStorage.getItem('authUser'))
      )
    }
  },
  computed: {
    showSidebar() {
      return this.$route.meta.requiresAuth
    }
  }
}
</script>

<style lang="scss">
@import 'assets/styles/main';
#app {
  font-family: Archivo, sans-serif;
  position: absolute;
  margin-top: 0;
  width: 100%;
}
.grid {
  display: grid;
  grid-template-columns: 3fr 8fr;

  @media screen and (max-width: 1365px) {
    grid-template-columns: 1fr;
  }
}
</style>
